import { z } from 'zod';
/** Schéma de pagination réutilisable pour les listes (query params). */
export const paginationQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(20),
    search: z.string().trim().max(200).optional(),
    sortBy: z.string().trim().max(60).optional(),
    sortDir: z.enum(['asc', 'desc']).default('desc'),
});
//# sourceMappingURL=pagination.js.map